module.exports = __webpack_public_path__ + "img/Fahrerseite_1T_Heckmotor.22335650.jpg";